import { FieldPath, FieldValues, useFormState } from 'react-hook-form';

import { Dict, ObjectFullPaths } from '@domain/app/Dict';
import { Translations, useTranslations } from '@domain/translations';

export const useWatchError = <TFieldValues extends FieldValues>(
    name: FieldPath<TFieldValues>,
    defaultErrorPath: ObjectFullPaths<Translations>,
) => {
    const { errors } = useFormState<TFieldValues>({ name });
    const t = useTranslations();

    const error = Dict.get(errors as any, name);
    const accountError = error && error.message;
    return accountError && Dict.get(t, accountError.toString(), Dict.get(t, defaultErrorPath));
};
